export default __webpack_public_path__ + "static/media/list_main_1_1.84f30fa5.png";